let Modernizr = {};

if (typeof window !== 'undefined') {
    const {default: addTest} = require('modernizr/addTest');
    Modernizr = require('modernizr/Modernizr').default;

    Modernizr.addTest = addTest;
    Modernizr.addAsyncTest = (cb: () => void) => cb();
}

export default Modernizr;
